import isBoolean from 'lodash/isBoolean';

/**
 * Track changes to variable selections appropriately in analytics.
 * Casts keys and values to GA-friendly events.
 *
 * @param changesObj Key/Value mapping of new variable settings.
 */
export function trackVariablesChanges(changes: Record<string, unknown>) {
  Object.entries(changes).forEach(([key, value]) => {
    analytics.track('Quote Variable Adjusted', {
      category: 'Quotes',
      label: key,
      value: isBoolean(value) ? Number(value) : value,
      key,
      updated_value: value,
    });
  });
}
